import i18n from 'services/base/i18n';

export default {
  versionInfoTitle:        () => i18n.pgettext('Pages|Manage Updates|History Modal|Version Info|Title', 'Version Info'),
  versionInfoFieldVersion: () => i18n.pgettext('Pages|Manage Updates|History Modal|Version Info|Fields', 'Firmware Version'),
  versionInfoFieldNotes:   () => i18n.pgettext('Pages|Manage Updates|History Modal|Version Info|Fields', 'RELEASE NOTES'),
  versionInfoButtonBack:   () => i18n.pgettext('Pages|Manage Updates|History Modal|Version Info|Buttons', 'BACK'),

  historyInfoTitleUpgrade:  () => i18n.pgettext('Pages|Manage Updates|History Modal|Upgrade Info|Title', 'Upgrade Info'),
  historyInfoTitleRestore:  () => i18n.pgettext('Pages|Manage Updates|History Modal|Restore Info|Title', 'Restore Info'),
  historyInfoFieldPangolin: () => i18n.pgettext('Pages|Manage Updates|History Modal|Upgrade Info|Fields', 'Pangolin'),
  historyInfoFieldSource:   () => i18n.pgettext('Pages|Manage Updates|History Modal|Upgrade Info|Fields', 'Source Version'),
  historyInfoFieldTarget:   () => i18n.pgettext('Pages|Manage Updates|History Modal|Upgrade Info|Fields', 'Target Version'),
};
